<script lang="ts">
    import { Button, Col, Nav, NavLink, NavItem } from "sveltestrap";
    import { ItemBullets, href, Dashboard, Dropdownexample } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Navs/Navs.json"
</script>
<Col md="6">
    <Card cardHeaderprops="pb-0" headerTitle={ItemBullets}>
        <div slot="contentbody">
            <div class="border nav-list">
                <Nav vertical class="nav-list-disc">
                    <NavItem>
                        <NavLink><i class="fa fa-angle-right" /><span>{Dashboard}</span>
                        </NavLink>
                    </NavItem>
                    {#each data.defaultNavdata as navItem}
                        <NavItem>
                            <NavLink >
                                <i class="fa fa-angle-right"/>
                                <span>  {navItem.name}</span>
                            </NavLink>
                        </NavItem>
                    {/each}
                </Nav>
            </div>
            <div class="onhover-dropdown navs-dropdown">
                <Button class="onhover-dropdown" color="primary">{Dropdownexample} <i class="icon-arrow-down"></i></Button>
                <div class="onhover-show-div">
                    <div class="nav-list">
                        <Nav vertical class="nav-list-disc">
                            <NavItem>
                                <NavLink >
                                    <i class="fa fa-angle-right" />
                                    <span> {Dashboard}</span>
                                </NavLink>
                            </NavItem>
                            {#each data.defaultNavdata as navItem}
                                <NavItem>
                                    <NavLink>
                                        <i class="fa fa-angle-right" />
                                        <span>{navItem.name}</span>
                                    </NavLink>
                                </NavItem>
                            {/each}
                        </Nav>
                    </div>
                </div>
            </div>
        </div>
    </Card>
</Col>